import { render, staticRenderFns } from "./iframes.vue?vue&type=template&id=8ef3ab5c&"
import script from "./iframes.vue?vue&type=script&lang=js&"
export * from "./iframes.vue?vue&type=script&lang=js&"
import style0 from "./iframes.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports